import {OktaAuth} from "@okta/okta-auth-js";

export function getOktaAuth(issuer: string|undefined, clientId: string|undefined): OktaAuth {
    return new OktaAuth({
        issuer: issuer,
        clientId: clientId,
        redirectUri: window.location.origin + "/login-success",
        scopes: ["openid", "media_center", "profile"],
        pkce: true
    });
}
